import React, { useMemo } from "react";
import clsx from "clsx";

import styles from "./switch.module.scss";

const Switch = ({
	label = "",
	enabled,
	onChange,
	sliderClass = "",
	disabled = false,
	useLockIcon = false,
}) => {
	const click = e => {
		if (disabled) return;
		const newValue = !enabled;
		if (onChange) onChange(newValue);
		e.preventDefault();
	};

	const getLabel = () => {
		if (label) {
			return (
				<label
					className={styles.label}
					onClick={click}
					data-autotest="switchLabel"
				>
					{label}
				</label>
			);
		} else return null;
	};

	const lockClass = useMemo(() => {
		let lockTypeClass;
		if (useLockIcon) {
			lockTypeClass = styles.lock;
			if (disabled) lockTypeClass = styles.lockDisabled;
			else if (enabled) lockTypeClass = styles.lockActive;
		}
		return lockTypeClass;
	}, [disabled, enabled, useLockIcon]);

	return (
		<span
			className={`${styles.wrapper} ${
				disabled ? `${styles.disabled}` : ""
			}`}
		>
			<label
				className={styles.switch}
				onClick={click}
				data-autotest="switchLabel"
			>
				<span
					className={clsx(styles.input, enabled && styles.checked)}
					data-autotest={enabled ? "checked" : "unChecked"}
				/>
				<span
					className={clsx(styles.slider, sliderClass, lockClass)}
					data-autotest="switchSlider"
				></span>
			</label>
			{getLabel()}
		</span>
	);
};

export default Switch;
